export default {"src":"/_next/static/media/map-desktop.37098fc0.svg","height":532,"width":1203,"blurWidth":0,"blurHeight":0};